import { cn } from '@/lib/utils';

/**
 * The Domino Peak tile mark.
 *
 * Drawn as an inline SVG rather than loaded from `/favicon.svg` so it inherits
 * `currentColor` and stays crisp in the sidebar at any size, with no extra
 * request on first paint.
 */
export function DominoMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      className={cn('text-brass', className)}
      role="img"
      aria-label="Domino Peak"
    >
      <rect
        x="7"
        y="2"
        width="18"
        height="28"
        rx="4"
        fill="currentColor"
        opacity="0.14"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <line x1="7" y1="16" x2="25" y2="16" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="12.5" cy="8" r="2" fill="currentColor" />
      <circle cx="19.5" cy="8" r="2" fill="currentColor" />
      <circle cx="16" cy="24" r="2" fill="currentColor" />
    </svg>
  );
}
